import { takeLatest, call, put } from 'redux-saga/effects';
import { GatewayManagementApi } from 'api';
import { apiCallStatus } from 'helpers/constants';
import logger from 'helpers/logger';
import { actionTypes } from './constants';
import {
    getGatewayList as getGatewayListActionCreator,
    getGatewayListAction,
    getGatewayTypeAction,
    getDriveApplicationAction,
    getUpdateAssetDriveApplicationAction
} from './actions';
import { getRenameGatewayAction, getGatewayInfoAction } from './GatewayDetails/actions';
import { RENAME_GATEWAY_REQUEST, actionTypes as ActionTypes } from './GatewayDetails/constants';
import { notify } from 'sharedComponents/GeneralNotification';
import { translate } from 'helpers/translateHelper';

function* getGatewayList(action) {
    const siteIdentifiers = action.payload;
    yield put(getGatewayListAction(apiCallStatus.LOADING));
    try {
        const responseList = yield call(GatewayManagementApi.getGatewayList, siteIdentifiers);
        yield put(getGatewayListAction(apiCallStatus.SUCCESS, responseList));
        logger.debug('Gateway List successfully loaded for page ');
    } catch (err) {
        yield put(getGatewayListAction(apiCallStatus.ERROR, [], err));
    }
}

function* getGatewayType() {
    yield put(getGatewayTypeAction(apiCallStatus.LOADING));
    try {
        const responseList = yield call(GatewayManagementApi.getGatewayType);
        yield put(getGatewayTypeAction(apiCallStatus.SUCCESS, responseList));
        logger.debug('Gateway Type successfully loaded for page ');
    } catch (err) {
        yield put(getGatewayTypeAction(apiCallStatus.ERROR, [], err));
    }
}
function* renameGatewayName(action) {
    yield put(getRenameGatewayAction(apiCallStatus.LOADING));
    yield put(getGatewayInfoAction(apiCallStatus.LOADING));
    yield put(getGatewayListAction(apiCallStatus.LOADING));
    try {
        const { gatewayID, newName, organizationID, filters, siteIds = [], gatewayFilter } = action.payload;
        const response = yield call(GatewayManagementApi.gatewayRename, gatewayID, newName);
        yield put(getRenameGatewayAction(apiCallStatus.SUCCESS, response));
        yield put(getGatewayInfoAction(apiCallStatus.SUCCESS, response));
        yield put({ type: ActionTypes.GET_GATEWAY_INFO, payload: action.payload });

        // Use getGatewayList action creator which handles organizationID/siteId logic
        yield put(getGatewayListActionCreator(
            organizationID,
            siteIds,
            filters,
            gatewayFilter
        ));
    } catch (error) {
        yield put(getRenameGatewayAction(apiCallStatus.ERROR, [], error));
    }
}


function* getDriveApplications() {
    yield put(getDriveApplicationAction(apiCallStatus.LOADING));
    try {
        const response = yield call(GatewayManagementApi.getDriveApplications);
        yield put(getDriveApplicationAction(apiCallStatus.SUCCESS, response));
        logger.debug('Drive applications successfully loaded for page ');
    } catch (error) {
        yield put(getDriveApplicationAction(apiCallStatus.ERROR, [], error));
    }
}

function* getUpdateAssetDriveApplication(action) {
    const { id, assetId, assetName, applicationId } = action.payload;
    yield put(getUpdateAssetDriveApplicationAction(apiCallStatus.LOADING));
    try {
        const response = yield call(GatewayManagementApi.updateAssetNameAndDriveApplication, id, assetId, assetName, applicationId);
        yield put(getUpdateAssetDriveApplicationAction(apiCallStatus.SUCCESS, response));
        notify(translate('ABB.Powertrain.Frontend.gatewayManagementAssetDetailsChangeSaved'), apiCallStatus.SUCCESS, false);
        yield put({
            type: ActionTypes.GET_GATEWAY_CONNECTED_ASSETS,
            payload: { gatewayID: action.gatewayID }
        });
    } catch (error) {
        yield put(getUpdateAssetDriveApplicationAction(apiCallStatus.ERROR, [], error));
    }
}

export function* GatewayManagementWatchers() {
    yield takeLatest(actionTypes.GET_GATEWAY_LIST, getGatewayList);
}

export function* GatewayTypeWatchers() {
    yield takeLatest(actionTypes.GET_GATEWAY_TYPE, getGatewayType);
}

export function* GatewayDetailsWatchers() {
    yield takeLatest(RENAME_GATEWAY_REQUEST, renameGatewayName);
}

export function* GatewayDriveApplicationsWatchers() {
    yield takeLatest(actionTypes.GET_DRIVE_APPLICATIONS, getDriveApplications);
}

export function* GatewayUpdateAssetDriveApplicationWatchers() {
    yield takeLatest(actionTypes.GET_UPDATE_ASSET_DRIVE_APPLICATION, getUpdateAssetDriveApplication);
}
